export enum BotPayload {
  form = 'form',
  faq = 'faq',
  media = 'media',
  schedulerData = 'schedulerData',
  input = 'input',
  docusign = 'docusign',
  emrSync = 'emrSync',
  quickReply = 'quickReply',
  carousel = 'carousel',
  signOff = 'signOff',
  command = 'command',
}

export enum MessageContent {
  botPayload = 'botPayload',
  userPayload = 'userPayload',
}
